export default __webpack_public_path__ + "static/media/people-laughing.42009292.webp";